import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import './login.css'
import { ErrorIcon } from './ErrorIcon';

function NotFound(props) {
    let navigate = useNavigate();
    return (
        <div className='login-container'>
            <div className='login-block'>
                <div style={{ textAlign: 'center' }}>
                    <ErrorIcon></ErrorIcon>
                </div>

                <div className='error-label'>Wrong lightning address</div>
                <div className='error-msg'>Please input a right lighting address</div>

                <Button style={{ backgroundColor: 'rgba(52, 82, 244, 1)', width: '100%' }}
                    onClick={() => {
                        props.cleanup();
                        navigate('/login');
                    }}
                >Go Back</Button>{' '}
            </div>
        </div>
    )
}

export default NotFound;